import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Breadcrumbs from "../../../reusebale/breadcrumbs";
import CompanyForm from "../company-information/company-form";
import UploadImage from "../company-information/upload-image";

import * as AuthAction from "../../../../store/actions/auth/AuthAction";

import BaseUrl from "../../../../constants/BaseUrl";
import { ShowError, ShowSuccess } from "../../../../utils/ToasFunction";

const CompanyInfo = ({ onBack }) => {
  const dispatch = useDispatch();

  const { loader, loginSuccess, userCompleteProfile } = useSelector(
    (state) => state.auth
  );
  const [imageObj, setImageObj] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleDeleteCurrentImage = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      publicId: userCompleteProfile?.companyInformation?.companyLogo?.public_id,
    });

    const requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      body: raw,
    };

    fetch(`${BaseUrl}api/uploads/cloudinary-delete`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.result === "ok") {
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        ShowError("Oops! Something went wrong");
      });
  };

  const UploadImageToServerImage = (file) => {
    setLoading(true);
    const formdata = new FormData();
    formdata.append("image", file);

    const requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    fetch(`${BaseUrl}api/uploads/cloudinary-upload`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.cloudinary?.secure_url) {
          setLoading(false);
          const profileImage = {
            url: result.cloudinary.secure_url,
            public_id: result.cloudinary.public_id,
            original_filename: result.cloudinary.original_filename,
          };
          setImageObj(profileImage);
          if (userCompleteProfile?.companyInformation?.companyLogo) {
            handleDeleteCurrentImage();
            updateCompanyImage(profileImage);
          }
        } else {
          ShowError(
            "Oops! Something went wrong. Please upload an image in JPEG or PNG format with a maximum size of 2MB"
          );
        }
      })
      .catch((error) => {
        setLoading(false);
        ShowError(
          "Oops! Something went wrong. Please upload an image in JPEG or PNG format with a maximum size of 2MB"
        );
      });
  };

  const updateCompanyImage = (imageObj) => {
    console.log("Update company logo");
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      landloardId: loginSuccess?.user?._id,
      companyInformation: {
        companyName: userCompleteProfile?.companyInformation?.companyName,
        companyWebsite: userCompleteProfile?.companyInformation?.companyWebsite,
        street1: userCompleteProfile?.companyInformation?.street1,
        street2: userCompleteProfile?.companyInformation?.street2,
        city: userCompleteProfile?.companyInformation?.city,
        state: userCompleteProfile?.companyInformation?.state,
        country: userCompleteProfile?.companyInformation?.country,
        zipCode: userCompleteProfile?.companyInformation?.zipCode,
        completeAddress:
          userCompleteProfile?.companyInformation?.completeAddress,
        longitude: "990.99",
        latitude: "3390.99",
        companyLogo: imageObj
          ? imageObj
          : userCompleteProfile?.companyInformation?.companyLogo,
      },
    });

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}landlord/profile/createNewProfile`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.status === "Success") {
          ShowSuccess("Profile image updated successfully");
          dispatch(
            AuthAction.GetLandlordProfile(
              loginSuccess?.user?._id,
              loginSuccess.token
            )
          );
        } else {
          ShowError("Failed to update profile image");
        }
      })
      .catch((error) => {
        ShowError("Failed to update profile image");
      });
  };

  return (
    <div className="mt-6 w-full">
      <Breadcrumbs
        recordId={`${loginSuccess?.user?.firstName} ${loginSuccess?.user?.lastName}`}
        subheading="My Account"
        onBack={onBack}
      />

      <div className="flex justify-between mt-5">
        <div className="w-[64%]">
          <CompanyForm imageUrl={imageObj} onBack={onBack} />
        </div>
        <div className="w-[34%]">
          <UploadImage
            loading={loading}
            imageUploadFunction={(imagePath) => {
              UploadImageToServerImage(imagePath);
            }}
            imagePath={
              imageObj?.url
                ? imageObj.url
                : userCompleteProfile?.companyInformation?.companyLogo?.url
            }
            imageTitle="Company Logo"
          />
          {/* <UploadImage
            imagePath={userCompleteProfile?.companyInformation?.companyLogo}

          /> */}
        </div>
      </div>
    </div>
  );
};

export default CompanyInfo;
